export default __webpack_public_path__ + "static/media/egg.354b5598.png";